import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { Toaster } from "sonner";
import { DonateProvider } from "./context/DonateContext";
import DonationReturnHandler from "./components/DonationReturnHandler";

function App() {
  return (
    <div className="App">
      <DonateProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </BrowserRouter>
        <DonationReturnHandler />
      </DonateProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
